import { getLinks, getStoryBySlug, Hero } from '@cinch-nx/data-storyblok'
import { PolicyPageStoryContent } from '@cinch-nx/landing-feature-policy-page'
import { InferGetStaticPropsType } from 'next/types'
import { GetStaticPropsContext } from 'next'

import { traceFunction, tagError, setTag } from '@core/datadog-server'

async function getStaticPropsFn({ preview = false }: GetStaticPropsContext) {
  try {
    setTag('page.name', 'modern-slavery-hub')
    setTag('page.rendered', 'ISR')
    setTag('page.revalidate-in', '60s')
    setTag(
      'page.params',
      JSON.stringify(
        {
          preview,
        },
        null,
        2,
      ),
    )

    const links = await getLinks('policies/modern-slavery-statement/statements')
    const story = await getStoryBySlug<PolicyPageStoryContent>(
      'policies/modern-slavery-statement/index',
    )

    const actualLinks = Object.values(links).filter(
      (link) => link.published === true,
    )

    if (!story) {
      throw new Error('No story found within modern slavery')
    }

    const HeroProps: Hero | undefined = story?.content?.hero?.[0]
    setTag('page.response-code', 200)

    return {
      props: {
        preview,
        links: actualLinks,
        layoutProps: {
          showBorderRadius: false,
          heroProps: HeroProps,
        },
      },
      revalidate: 60, // In seconds
    }
  } catch (error) {
    if (error instanceof Error || typeof error === 'string') {
      tagError(error)
    }

    setTag('page.response-code', 404)

    return {
      notFound: true,
      props: {
        links: [],
        layoutProps: {
          showBorderRadius: false,
        },
      },
      revalidate: 60, // In seconds
    }
  }
}

export const getStaticProps = traceFunction(
  'modernSlaveryHub.getStaticProps',
  getStaticPropsFn,
)

export type ModernSlaveryHubProps = InferGetStaticPropsType<
  typeof getStaticProps
>
